import { IDropDownNavigation } from '../shared-interfaces/IDropDownNavigation';
import * as React from 'react';
import { Grid, Typography } from '@mui/material';
import DropDownArrow from './DropDownArrow';
import { useRef, useEffect } from 'react';

const DropDownNavigation = (props: IDropDownNavigation) => {
  const ref = useRef<Element>(null);
  useEffect(() => {
    if (props.index === props.activeDropdown) {
      const onMouseDown = (e: MouseEvent) => {
        if (ref.current != null && ref.current.contains(e.target)) {
          // click inside
        } else if (openDropDown) {
          // click outside active
          props.setActiveDropdown(-1);
        }
      };
      document.addEventListener('mousedown', onMouseDown);
      return () => {
        document.removeEventListener('mousedown', onMouseDown);
      };
    }
  }, [props.index, props.activeDropdown, ref.current]);
  const openDropDown = props.index === props.activeDropdown;
  const onInteraction = () => {
    props.setActiveDropdown(openDropDown ? -1 : props.index);
  };
  const links = Array.isArray(props.children)
    ? props.children
    : [props.children];
  return (
    <div
      onClick={onInteraction}
      onKeyPress={event => {
        if ((event.keyCode || event.which) === 13) {
          onInteraction();
        }
      }}
      className={'nav-dropdown ' + (props.active ? 'active' : '')}
      tabIndex={0}
      ref={ref}
    >
      <Grid
        container
        direction="row"
        alignItems="center"
        className="nav-padding"
      >
        <Grid item>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <Typography>{props.name}</Typography>
            <DropDownArrow up={openDropDown} />
          </div>
        </Grid>
      </Grid>
      <Grid
        container
        direction="column"
        className="dropdown-content"
        style={
          props.index === props.activeDropdown ? undefined : { display: 'none' }
        }
      >
        {links
          .filter(x => x)
          .map((link, i) => {
            return (
              <Grid item key={i}>
                {link}
              </Grid>
            );
          })}
      </Grid>
    </div>
  );
};

export default DropDownNavigation;
